export class ExternalUrls {
  static readonly LineupPricing = 'https://www.lineupteams.com/pricing';
  static readonly LineupUpgrade = 'https://www.lineupteams.com/upgrade';
}
